import React from 'react';
import { CollapseList, ICollapseListProps } from '@lion-design/core';
import { CustomTable, I_CustomTableProps } from './subComponents/CustomTable';
import { TableContent } from './subComponents/TableContent';
import styles from './styles.module.scss';

type I_Props =
    | (ICollapseListProps & { tableElement?: never })
    | (I_CustomTableProps & { dataSource?: never });

const Table: React.FC<I_Props> = ({ titles, dataSource, tableElement }) => {
    return tableElement ? (
        <CustomTable titles={titles} tableElement={tableElement} />
    ) : (
        <CollapseList titles={titles} dataSource={dataSource} className={styles.table} />
    );
};

export type { I_CustomTableProps };
export { TableContent };
export default Table;
